import { StatusChip } from './StatusChip';
import type { Column } from './DataTable';

/** The last column of the customer, agent and carrier tables: Active / Inactive as a chip */
export function statusColumn<T extends { status: string }>(): Column<T> {
  return {
    header: 'Status',
    nowrap: true,
    action: true,
    render: (r) => <StatusChip label={r.status} tone={r.status === 'Active' ? 'success' : 'neutral'} />,
  };
}

/** A "Last Activity" column from a function that gives the date text (or "" for none) */
export function lastActivityColumn<T>(get: (row: T) => string): Column<T> {
  return { header: 'Last Activity', nowrap: true, render: (r) => get(r) || '—' };
}
